import Suggestions from 'design-system/suggestions/Suggestions';
import React from 'react';
const SUGGESTIONS_DATA = [
    {
        name: 'Family',
    },
    {
        name: 'Bills',
    },
    {
        name: 'Home',
    },
    {
        name: 'Food',
    },
    {
        name: 'Rent',
    },
    {
        name: 'Joint',
    },
    {
        name: 'Spain',
    },
    {
        name: 'Greece',
    },
    {
        name: 'Italy',
    },
];
const GroupNameSuggestions = ({ name, handleSuggestionPress, suggestedData, }) => (<Suggestions title="Suggestions" data={SUGGESTIONS_DATA} name={name} handleSuggestionPress={handleSuggestionPress} suggestedData={suggestedData}/>);
export default GroupNameSuggestions;
